import { H2 } from "@/shared/ui/typographies/h2";
import { P } from "@/shared/ui/typographies/paragraph";

export const CardWelcomeSlideHeader = () => (
  <div
    data-testid="card-welcome-slide"
    className="text-center space-y-4 animate-fade-in"
  >
    <H2 className="text-primary text-pretty">
      Activez votre nouvelle carte Yeati
    </H2>
    <div className="flex flex-col text-center">
      <P className="text-base animate-slide-up text-pretty">
        Vous avez reçu votre nouvelle carte ?
      </P>
      <P className="text-base animate-slide-up text-pretty">
        Activez-la dès maintenant pour commencer à l'utiliser.
      </P>
    </div>
  </div>
);
